import React, { useState } from "react";

function Login({ onAuthenticate }) {
  const [password, setPassword] = useState("");

  const handleLogin = () => {
    onAuthenticate(password);
  };

  return (
    <div style={{ textAlign: "center", marginTop: "2rem" }}>
      <h2>Admin Login</h2>
      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Enter admin password"
        style={{
          padding: "0.5rem",
          fontSize: "1rem",
          margin: "0.5rem",
          border: "1px solid #ccc",
          borderRadius: "4px",
        }}
      />
      <button
        onClick={handleLogin}
        style={{
          padding: "0.5rem 1rem",
          fontSize: "1rem",
          backgroundColor: "#4f46e5",
          color: "#fff",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        Login
      </button>
    </div>
  );
}

export default Login;
